import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  display: grid;
  grid-template-columns: 33% 33% 33%;
  grid-row-gap: 50px;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1230px;
  margin:0 auto;
  min-height:calc(100vh - 110px);
  align-items:center;
  @media (min-width: 1000px) and (max-width: 1366px) {
    grid-template-columns:  33% 33% 33%;
     width: 100%;
  }
  @media (max-width: 999px) {
    grid-template-columns:  100%;
    width:auto;
    padding-top:30px;
  }
`;
export const BlockText = styled.div`
  display: block;
  color: ${(props) => (props.color ? props.color : "")};
  font-weight: 600;
  @media (max-width:1366px){
    br {
      display:none
    }
  }
`;

export const Block = styled.div`
  border-radius: 20px;
  border: 0px solid grey;
  margin: 10px;
  position: relative;
  text-align:center;
  transition: all 0.4s ease 0s;
  cursor : pointer;
  padding: 20px 15px;
  &:hover{
    box-shadow: 0px 0px 30px -14px rgba(0,0,0,0.5);
    transform:scale(1.05);
  }
`;

export const Block1 = styled.div`
  border-radius: 20px;
  color: lightgrey;
  margin: 10px;
  text-align:center;
  &:hover{
    color: lightgrey;
    background: ${(props) => (props.background ? props.background : "")};
  }
  position: relative;
`;

export const Icon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color:grey;
  &>*{
    &:hover{
      color: white;
    }
  } 
  
`;

export const Upload = styled.div`
  position: absolute;
  width: 200px;
  top: 50px;
  right: 30px;
  display: grid;
  grid-template-columns: 15% 85%;
  font-weight: 600;
  font-size: 14px;
  color: grey;
`;

export const Setting = styled.div`
  position: absolute;
  width: 130px;
  top: 50px;
  right: 100px;
  display: grid;
  grid-template-columns: 70% 30%;
`;


export const Ad = styled.div`
  margin-top:5%;
  margin-right:5%;
  margin-left:-15%;
`
export const RowClass = styled.div`
--bs-gutter-x: 1.5rem;
--bs-gutter-y: 0;
display: flex;
flex-wrap: wrap;
margin-top: 0;
margin-right: 0;
margin-left: 0;
padding: 0 25px;
.text-right{
  text-align:right
}
`
export const LogoOgilvy = styled.img`
    max-width: 150px;
    position: relative;
    top: 50px;
    margin-right: 50px;
`
const growRotate = keyframes`
  0% {
    transform: scale(1) rotate(0deg);
  }
  20% {
    transform: scale(1.5) rotate(180deg);
  }
  50% {
    transform: scale(1.5) rotate(180deg);
  }
  100% {
    transform: scale(1) rotate(360deg);
  }
`;

export const SettingIcon = styled.img`
    max-width: 30px;
    position: relative;
    top: 55px;
    right:20px;
    cursor:pointer;
    animation: ${growRotate} 30s infinite;
}
`